import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
};

export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR');
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleString('pt-BR');
};

export const getTitleStatusLabel = (status) => {
  const labels = {
    'pendente': 'Pendente',
    'parcial': 'Parcial',
    'pago': 'Pago',
    'vencido': 'Vencido',
    'cancelado': 'Cancelado',
  };
  return labels[status] || status;
};

export const getTitleStatusColor = (status) => {
  const colors = {
    'pendente': 'bg-yellow-100 text-yellow-800 border-yellow-300',
    'parcial': 'bg-blue-100 text-blue-800 border-blue-300',
    'pago': 'bg-green-100 text-green-800 border-green-300',
    'vencido': 'bg-red-100 text-red-800 border-red-300',
    'cancelado': 'bg-gray-100 text-gray-800 border-gray-300',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const formatCPF = (cpf) => {
  if (!cpf) return '';
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};